'use client';
import Link from 'next/link';
import { PLAYWRIGHT_IGNORE } from '@/lib/constants';
import CarouselReactMulti from '@/components/CarouselReactMulti';
import BGImageCard from '../components/BGImageCard';
import { heroCardData } from './heroSection.copy';
import { ChevronRightIcon } from '@heroicons/react/20/solid';

export const HeroSection: React.FC = () => {
  return (
    <section className="min-h-screen-with-nav flex flex-col bg-gray-1 text-white">
      <div className="py-section flex h-full w-full flex-1 flex-col justify-center gap-8">
        <div className="mx-auto flex h-full max-w-[70rem] flex-col gap-2 px-4 md:px-10 lg:flex-row xl:flex-row">
          <h1 className="text-h2 flex-1 text-left">
            Develocity featured
            <br />
            customer stories
          </h1>
          <div className="flex flex-1 flex-col gap-5 md:gap-7 lg:gap-10 xl:gap-10">
            <p className="text-body text-gray-4">
              Learn how these global technology and business brands are leveraging Develocity® to solve top developer
              productivity pain points and improve developer experience.
            </p>
            <Link
              className="underline-text-transition-blue text-body group flex w-fit items-center gap-1 whitespace-nowrap"
              href="#CustomersMeetOurCustomersSection"
            >
              <span>See all stories</span>{' '}
              <ChevronRightIcon className="inline-block size-6 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
        <div className="flex flex-col gap-8" data-testid={PLAYWRIGHT_IGNORE}>
          <CarouselReactMulti>
            {heroCardData.map((card, idx) => (
              <BGImageCard
                key={`item_${idx}`}
                bgImage={card.bgImage}
                icon={card.icon}
                text={card.text}
                type={card.type}
                gradientColor={card.gradientColor}
                target={card.target}
              />
            ))}
          </CarouselReactMulti>
        </div>
      </div>
    </section>
  );
};
